import React from 'react'
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';

const setOrder = (filedName, sortObject) => {
    if (sortObject.orderBy === filedName) {
        if (sortObject.order === 'asc') {
            return {order: 'ASC'}
        } else if (sortObject.order === 'desc') {
            return {order: 'DESC'}
        }
        return {order: 'none'}
    }
    return {order: 'none'};
};


const renderSortIcon = () => {
    return (
        <span className='sort-arrow-group'>
              <ArrowDropUpOutlinedIcon />
        </span>
    );
};

export const sortConfig = (filedName, sortObject) => {
    const result = setOrder(filedName, sortObject);
    switch (result.order) {
        case 'ASC':
            return renderSortIcon('ASC');
        case 'DESC':
            return renderSortIcon('DESC');
        default:
            return renderSortIcon('DESC');
    }
};


export const renderSortIcons = renderSortIcon;